import TendersOnReturn from './TendersOnReturn';

export default {
  title: 'Return without receipt',
  description:
    'Choose the tendering methods available for a Return without invoice. You can also set limits for cash, separate card payments and etc.',
  path: '/pos-settings/tenders/return',
  component: TendersOnReturn,
  rootPath: { name: 'POS Settings', uri: '/pos-settings' },
  subPath: [
    { name: 'Payment Tenders', uri: '/pos-settings/tenders' },
    { name: 'Return Without Receipt' },
  ],
};
